(ns common.widgets.form-field
  (:require ["@mui/material/Stack$default" :as Stack]
            ["@mui/material/Typography$default" :as Typography]
            ["react" :as react]
            [uix.core :refer [defui $]]))

(defui hint
  [{:keys [children]}]
  ($ Typography
     {:variant "caption"
      :sx #js {:color "#082040"}}
     children))

(defui form-field
  [{:keys [label err-msg data-testid required? label-action children] :as props}]
  (let [children-count (react/Children.count children)]
    ($ Stack (-> props
                 (dissoc :label :err-msg :required? :label-action)
                 (assoc :spacing 1
                        :data-component :form-field))
       (cond
         (string? label)
         ($ Stack {:direction "row" :gap 0.5 :alignItems "center"}
            ($ Typography
               {:component "label"
                :fontWeight "600"
                :color "text.subtle"
                :data-testid (some-> data-testid (str "-label"))
                :data-component :form-field__label}
               label)
            (when required? ($ Typography {:color "error"} "*"))

            (when label-action label-action))

         (some? label)
         label)

       ($ Stack {:data-component :form-field__control}
          (if (> children-count 1)
            (first children)
            children))

       (when err-msg
         ($ Typography
            {:fontWeight "600"
             :variant "caption"
             :color "error"
             :whiteSpace "normal"
             :data-testid (some-> data-testid (str "-err-msg"))
             :data-component :form-field__err-msg}
            err-msg))

       (when (> children-count 1)
         (rest children)))))
